const setAreaOfExpertiseError = message => ({
  type: 'SET_AREA_OF_EXPERTISE_ERROR',
  message,
});

export default setAreaOfExpertiseError;
